import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

const bulkEditCondLogic = async ({ testCaseId, data, condLogic, condexp }) => {
  const userDetailString = localStorage.getItem("userDetail");
  if (!userDetailString) throw new Error("No user details found in localStorage");

  const user = JSON.parse(userDetailString);

  const response = await axios.post(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=updateBulkCondLogic&condLogic=${condLogic}&condexp=${encodeURIComponent(condexp)}&companyid=${user.companyid}&testCaseId=${testCaseId}`,
    data,
  );

  return response.data;
};

const useBulkEditCondLogic = () => {
  return useMutation({
    mutationFn: (variables) => bulkEditCondLogic(variables),
  });
};

export default useBulkEditCondLogic; 